module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-card p-component"
  }, [(_vm.$slots.header) ? _c('div', {
    staticClass: "p-card-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-card-body"
  }, [(_vm.$slots.title) ? _c('div', {
    staticClass: "p-card-title"
  }, [_vm._t("title")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.subtitle) ? _c('div', {
    staticClass: "p-card-subtitle"
  }, [_vm._t("subtitle")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-card-content"
  }, [_vm._t("content")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "p-card-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a9204d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/card/Card.vue
// module id = 2318
// module chunks = 0